import axios from 'axios';

const instance = axios.create({
    baseURL: window.location.origin
});

function getDatasets(datasourceId) {
    return instance.get(`api/SmartGrabber/${datasourceId}/datasets`);
}

function getTables(datasourceId, datasetId) {
    return instance.get(`api/SmartGrabber/${datasourceId}/datasets/${datasetId}/tables`);
}

function getTable(datasourceId, datasetId, tableId) {
    return instance.get(`api/SmartGrabber/${datasourceId}/datasets/${datasetId}/tables/${tableId}`);
}

function getColumnDistinctValues(datasourceId, datasetId, tableId, columnName, searchText) {
    return instance.get(`api/SmartGrabber/${datasourceId}/datasets/${datasetId}/tables/${tableId}/column-distinct-values`, {
        params: {
            columnName: columnName,
            searchText: searchText
        }
    });
}

function getQueryResult(datasourceId, datasetId, tableId, queryModel) {
    return instance.post(`api/SmartGrabber/${datasourceId}/datasets/${datasetId}/tables/${tableId}/query`, queryModel);
}

function getCsvResult(datasourceId, datasetId, tableId, queryModel) {
    return instance.post(`api/SmartGrabber/${datasourceId}/datasets/${datasetId}/tables/${tableId}/export-query-result`, queryModel);
}

function getBrands() {
    return instance.get(`api/SmartGrabber/brands`);
}

export default {
    getDatasets,
    getTables,
    getTable,
    getColumnDistinctValues,
    getQueryResult,
    getCsvResult,
    getBrands
};

